/* eslint-disable jsx-a11y/href-no-hash */
import React, { PureComponent } from 'react'
import moment from 'moment'
import { Collapse, Pagination, Menu, Dropdown, Icon } from 'antd'
import { drop } from 'lodash'

const { Panel } = Collapse
const { Item } = Menu

const menu = (setFilter, currentFilter) => (
  <Menu>
    <Item onClick={() => setFilter('All')}>
      All {currentFilter === 'All' && <Icon type="check" />}
    </Item>
    <Item onClick={() => setFilter('Active')}>
      Active {currentFilter === 'Active' && <Icon type="check" />}
    </Item>
    <Item onClick={() => setFilter('Design')}>
      Design {currentFilter === 'Design' && <Icon type="check" />}
    </Item>
    <Item onClick={() => setFilter('Work in progress')}>
      Work in progress {currentFilter === 'Work in progress' && <Icon type="check" />}
    </Item>
    <Item onClick={() => setFilter('Complete')}>
      Complete {currentFilter === 'Complete' && <Icon type="check" />}
    </Item>
    <Item onClick={() => setFilter('Inactive')}>
      Inactive {currentFilter === 'Inactive' && <Icon type="check" />}
    </Item>
    <Item onClick={() => setFilter('Manufacturing')}>
      Manufacturing {currentFilter === 'Manufacturing' && <Icon type="check" />}
    </Item>
    <Item onClick={() => setFilter('Dead')}>
      Dead {currentFilter === 'Dead' && <Icon type="check" />}
    </Item>
  </Menu>
)

class Jobs extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      filter: 'All'
    }
  }
  setFilter = filter => {
    this.setState({
      filter,
      page: 1
    })
  }
  setPage = page => {
    this.setState({
      page
    })
  }
  getFilteredData = () => {
    const data = this.props.companyJobs || []
    const { filter } = this.state
    if (filter === 'All') {
      return data
    }
    return data.filter(f => f.status.toLowerCase() === filter.toLowerCase())
  }
  getPagedData = () => {
    const { page } = this.state
    const data = this.getFilteredData()
    const offset = (page - 1) * 5
    return drop(data, offset).slice(0, 5)
  }
  renderElement = data => {
    const { name, type, created_date, id } = data
    const date = moment(created_date).format('M/D/YYYY')
    return (
      <Panel key={id} header={name}>
        <div className="row">
          <div className="col-md-8">
            <div className="jobDetailsHeader">Name:</div>
            <span>{name}</span>
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Type:</div>
            <span>{type}</span>
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Date created:</div>
            <span>{date}</span>
          </div>
        </div>
      </Panel>
    )
  }
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className="jobsBar">
              Jobs
              <div className="pull-right">
                <Dropdown overlay={menu(this.setFilter, this.state.filter)}>
                  <a className="ant-dropdown-link" href="#" style={{ color: '#fff' }}>
                    Filter by status <Icon type="down" />
                  </a>
                </Dropdown>
              </div>
            </div>
          </div>
        </div>
        <Collapse>{this.getPagedData().map(this.renderElement)}</Collapse>
        <Pagination
          total={this.getFilteredData().length}
          pageSize={5}
          current={this.state.page}
          defaultCurrent={1}
          onChange={this.setPage}
        />
      </div>
    )
  }
}

export default Jobs



// WEBPACK FOOTER //
// ./src/components/company/Jobs.js